module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header'), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      },
      "wheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "page",
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [(_vm.init) ? _c('div', {
    staticClass: "line"
  }) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [(_vm.init) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].contact))]) : _vm._e()])], 1), _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    on: {
      "enter": _vm.enter,
      "beforeEnter": _vm.beforeEnter
    }
  }, [(_vm.animateCtrl[0]) ? _c('b-footer', {
    staticClass: "footer"
  }) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "copyright"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].copyright))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b4dd465","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact.vue
// module id = 510
// module chunks = 1